import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@/components/ui/typography'

import * as S from './empty-state.styled'

export interface EmptyStateProps {
  title?: string
  description?: string
  image?: {
    src: string
    alt: string
    width: string
  }
  actions?: ReactNode
}

export const EmptyState = ({ title, description, image, actions }: EmptyStateProps) => {
  const { t } = useTranslation(['common'])
  const resolvedTitle = title ?? t('common:emptyState.title')
  const resolvedImage = image ?? {
    alt: t('common:emptyState.imageAlt'),
    src: '/images/no-results.svg',
    width: '8rem',
  }

  return (
    <S.Container>
      <S.Image src={resolvedImage.src} alt={resolvedImage.alt} $width={resolvedImage.width} />
      <S.Content>
        <Typography as="h3" size="heading-medium" color="black800">
          {resolvedTitle}
        </Typography>
        {description && (
          <Typography size="text-large" color="black500">
            {description}
          </Typography>
        )}
      </S.Content>
      {actions && <S.Actions>{actions}</S.Actions>}
    </S.Container>
  )
}
